import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const BasicSubmitButton = props => {
  const {
    btnWidth = 200,
    btnHeight = 40,
    btnText = 'Button Text',
    btnFontSize = '0.9286rem',
    btnFontWeight = 400,
    btnArrow = true,
    btnBg = 'transparent',
    btnTextColor = '#27282d',
    btnHoverBg = '#f40',
    btnHoverTextColor = '#fff',
    disabled = false,
    controlFunc,
  } = props;

  const [hover, setHover] = useState(false);

  const hoverOn = () => {
    setHover(true);
  };

  const hoverOff = () => {
    setHover(false);
  };

  const btnStyles = {
    backgroundColor: hover ? btnHoverBg : btnBg,
    color: hover ? btnHoverTextColor : btnTextColor,
    fontSize: btnFontSize,
    minHeight: btnHeight + 'px',
    minWidth: btnWidth + 'px',
    fontWeight: btnFontWeight,
  };

  const disabledStyles = {
    backgroundColor: '#ebebeb',
    borderColor: '#ebebeb',
    cursor: 'not-allowed',
    fontSize: btnFontSize,
    minHeight: btnHeight + 'px',
    minWidth: btnWidth + 'px',
    fontWeight: btnFontWeight,
  };

  return (
    <>
      {!!disabled ? (
        <button
          type="button"
          style={disabledStyles}
          className="basic-submit-button basic-submit-button--disabled"
          onMouseEnter={hoverOn}
          onMouseLeave={hoverOff}
          onMouseOver={hoverOn}
          onMouseOut={hoverOff}
          onMouseUp={hoverOn}
          onMouseDown={hoverOff}
          onFocus={hoverOn}
          onBlur={hoverOff}
        >
          <div className="basic-submit-button__text">{btnText}</div>
          {btnArrow && <span className="basic-submit-button__icon-arrow" />}
        </button>
      ) : (
        <button
          type="submit"
          onClick={controlFunc}
          style={btnStyles}
          className="basic-submit-button"
          onMouseEnter={hoverOn}
          onMouseLeave={hoverOff}
          onMouseOver={hoverOn}
          onMouseOut={hoverOff}
          onMouseUp={hoverOn}
          onMouseDown={hoverOff}
          onFocus={hoverOn}
          onBlur={hoverOff}
        >
          <div className="basic-submit-button__text">{btnText}</div>
          {btnArrow && <span className="basic-submit-button__icon-arrow" />}
        </button>
      )}
    </>
  );
};

BasicSubmitButton.propTypes = {
  disabled: PropTypes.bool,
  btnWidth: PropTypes.number,
  btnHeight: PropTypes.number,
  controlFunc: PropTypes.func,
  btnText: PropTypes.string.isRequired,
  btnFontSize: PropTypes.string,
  btnFontWeight: PropTypes.number,
  btnBg: PropTypes.string,
  btnTextColor: PropTypes.string,
  btnHoverBg: PropTypes.string,
  btnHoverTextColor: PropTypes.string,
  btnArrow: PropTypes.bool.isRequired,
};

export default BasicSubmitButton;
